<!-- The module context is to turn this file into a library or singleton -->
<script context="module">

    // apollo. make sure to use the 'core' package otherwise it pulls in
    // react as dependency, which will cause errors when rendering
    // https://github.com/apollographql/apollo-client/issues/6207#issuecomment-620493786
    import { ApolloClient, ApolloLink, HttpLink, InMemoryCache, gql as _gql } from '@apollo/client/core';
    import { setContext } from 'apollo-link-context';
    import { onError } from 'apollo-link-error';
    import { setClient } from 'svelte-apollo';
    import { query as _query, mutate as _mutate } from 'svelte-apollo';
    import { Observable } from 'rxjs';

    export function printDebug() {
        // env var parsed at compile time in Rollup conf
        console.log(`GRAPHQL ENDPOINT: ` + GRAPHQL_ENDPOINT);
    }

    // connection configuration for graphql endpoint
    const httpLink = new HttpLink({
        uri: "/api/v1/graphql",
        //accept: 'application/json',
        fetchOptions: {
            //mode: 'no-cors',
        },
    });

    /*const addStatusLink = new ApolloLink((operation, forward) => {
      return forward(operation).map((response) => {
        let x = 0;
        debugger;
        return response;
      })
    });*/

    // TODO: handle non-200 codes
    // https://github.com/apollographql/apollo-link/issues/1022#issuecomment-595068226
    const errorLink = onError(({ response, graphQLErrors, networkError, operation, forward }) => {
        if (graphQLErrors) {
            const headers = operation.getContext().headers;

            console.log(`processing ${graphQLErrors.length} response errors...`);

            for (let err of graphQLErrors.reverse()) {
                // some Null-error things do not have a code
                if (!err.extensions) {
                    continue;
                }

                console.log(`processing ${err.extensions.code}...`);

                // handle errors differently based on its error code
                switch (err.extensions.code) {

                    // TODO: this is still example code
                    // also check https://stackoverflow.com/q/60110561/399058
                    case "5.2.1":
                        console.log(`Authentication error.`);
                        /*
                        // old token has expired throwing AuthenticationError,
                        // one way to handle is to obtain a new token and
                        // add it to the operation context
                        operation.setContext({
                            headers: {
                                ...headers,
                                authorization: getNewToken(),
                            },
                        });
                        // Now, pass the modified operation to the next link
                        // in the chain. This effectively intercepts the old
                        // failed request, and retries it with a new token
                        return forward(operation);
                        */

                    case "UNAUTHORIZED_ACCESS":
                        console.log(`Authentication error.`);

                    case "INVALID_OPERATION": {
                        console.log(`Server-side C# error (see Network Requests)`);
                        //console.error(err);

                        // remove error from response
                        if (response) {
                            let beforeCount = response.errors.length;
                            response.errors.splice(response.errors.indexOf(err), 1);
                            if (beforeCount == response.errors.length) {
                                throw "expected graphql error to have been removed!";
                            }
                        }
                        else {
                            console.log("could not consume graphql errors... no response passed");
                        }
                        break;
                    }

                    default: {
                        console.log(`left ${err.extensions.code} untouched`);
                    }
                }

                // TODO: filter 'Cannot return null for non-null type.'
                /*if (err.message && err.message.contains("Cannot return null for non-null type")) {
                    alert("NULL TYP{E ERR");
                }*/
            }

            if (response)
                response.errors.forEach(console.error);

            // if the response has a status code indicating a server error,
            // and yet we managed to resolve the graphql errors, mimic
            // a succesful request by returning a "new" request that contains the data that
            // did come across successfully. This is all cool, but nevertheless,
            // JVT should not have returned these errors in the first place.

            let hasResponseData = response && response.data && Object.entries(response.data).length && !!Object.entries(response.data)[0][1];
            let isErrorResponse = operation.getContext().response.status == 400;
            let isRegisterUserResponse = hasResponseData && 'registerUser' in response.data;
            let isSuccessfulRegisterUserResponse = isRegisterUserResponse && response.data.registerUser && response.data.registerUser.token;
            let isLoginResponse = hasResponseData && 'login' in response.data;
            let isResponseFine = !response || !isErrorResponse;
            let moveToOk = !isResponseFine
                && hasResponseData
                && !isLoginResponse
                && (
                     !isRegisterUserResponse
                  || isSuccessfulRegisterUserResponse
                );

            // we dont want to filter errors out of login and registration requests...
            // unless a token is returned. Annoying JVT edge case of returning an error on success
            if (moveToOk) {
                console.log(`no errors in GraphQL response have remained after parsing. Moving response status to 200`);

                operation.setContext({
                    headers: {
                        ...headers,
                        statusCode: 200,
                    },
                });

                return new Observable(observer => {
                    observer.next({
                        data: response.data,
                        extensions: response.extensions,
                        context: operation.getContext()
                    });
                    observer.complete();
                });
            }
        }
      });

    export function clientForUser(userToken) {
        const authLink = setContext((_, { headers }) => {
            let token = userToken || localStorage.getItem('token');

            if (!token)
                debugger;

            // return the headers to the context so httpLink can read them
            return {
                headers: {
                    ...headers,
                    authorization: token ? `Bearer ${ token }` : "",
                }
            }
        });
        return new ApolloClient({
            cache: new InMemoryCache(),
            link: errorLink.concat(authLink).concat(httpLink),
            defaultOptions: {
                watchQuery: {
                    //fetchPolicy: 'cache-and-network',
                    errorPolicy: 'all',
                },
                query: {
                    //fetchPolicy: 'cache-and-network',
                    errorPolicy: 'all',
                },
                mutate: {
                    errorPolicy: 'all',
                },
            },
        });
    }

    // apollo setup
    export const client = clientForUser( );

    // wrap svelte-apollo call and provide client
    export const query = (q, vars) => _query(client, {
        query: q,
        variables: vars || {}
    });

    // wrap svelte-apollo call and provide client
    export const mutate = (m, vars) => _mutate(client, {
        mutation: m,
        variables: vars || {}
    });

    // function for resetting state after login/logout
    export const reset = client.resetStore;

    // re-export query template builder
    export const gql = _gql;

</script>